var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooth28(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.93 190.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m26.67,1.15c8.71,0,13.07,0,19.83,4.84,6.76,4.84,15.7,9.67,14.09,21.77-1.61,12.09-4.82,36.28-8.84,43.54-4.01,7.26-2.76,33.86-2.76,33.86l-4.02,53.21-2.99,29.02s-3.9,9.67-9.28-12.09S13.69,95.48,13.46,90.64c-.23-4.84-3.32-24.19-8.13-33.86-4.81-9.67-6.29-41.12.01-45.95C11.65,5.99,17.96,1.15,26.67,1.15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m29.87,22.92s-.23-4.84,4.01-7.26,8.6-2.42,12.95-2.42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m14.4,18.08s10.77-2.42,12.95-2.42,2.18,0,4.13-4.84"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m16.57,64.04s13.52,9.67,28.54,4.84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooth28);
export default __webpack_public_path__ + "static/media/tooth-28.cfe4ddc431f0fe72ceb0c21928d0043f.svg";
export { ForwardRef as ReactComponent };